// extracted by css-extract-rspack-plugin
export default {"thumbArrow":"_88a64636","thumbArrowUp":"_65507153","thumbArrowDown":"_204d9664"};